// components/ProtectedLayout.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useAutoLogout from "./Utils/AutoLogout";

/**
 * Auth + optional role gate.
 * - Requires accessToken (redirects to login).
 * - If `roles` is provided, userRole must be in that list (else redirect to fallbackPath).
 * Mirrors Sidebar2 AdminRoutes vs SubAdminRoutes without changing business rules.
 */
const ProtectedLayout = ({ children, roles, fallbackPath = "/dashboard" }) => {
  useAutoLogout(3600000); // 1 hour inactivity
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state?.user?.accessToken);
  const userRole = useSelector((state) => state?.user?.userRole);

  useEffect(() => {
    if (!accessToken) {
      navigate("/");
      return;
    }
    if (roles && roles.length > 0 && !roles.includes(userRole)) {
      navigate(fallbackPath);
    }
  }, [accessToken, userRole, roles, fallbackPath, navigate]);

  if (!accessToken) {
    return null;
  }
  if (roles && roles.length > 0 && !roles.includes(userRole)) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedLayout;
